const faqItems = [
  {
    q: '青青草视频是什么？',
    a: '青青草视频是一个在线视频平台资源聚合导航网站。我们汇聚了久久视频、芒果视频、97视频、丝瓜视频、蓝莓视频、91在线视频、糖心视频、黑桃视频等多个主流视频平台的入口，帮助用户在一个页面上快速找到所需的视频网站，节省反复搜索的时间。',
  },
  {
    q: '青青草视频是否需要注册或付费？',
    a: '不需要。青青草视频是一个完全免费的导航页面，用户可以直接访问和使用，无需注册账号，也无需支付任何费用。我们仅提供平台入口导航，各视频平台自身的会员服务请以对应平台为准。',
  },
  {
    q: '平台推荐的视频网站是否安全？',
    a: '我们严格把关所有收录的平台入口。每个视频网站都经过人工审核验证，确保链接安全有效。我们致力于为用户提供绿色健康的上网环境，所有推荐的在线视频平台均为正规运营的视频网站。',
  },
  {
    q: '如何推荐新的视频平台给青青草视频？',
    a: '如果您是视频平台的运营方，或知道优质的视频网站资源，欢迎通过联系我们页面的微信、邮件或在线留言方式向我们推荐。我们的团队会尽快审核并考虑收录。',
  },
  {
    q: '青青草视频多久更新一次内容？',
    a: '我们的内容入口保持每日更新节奏。无论是各平台的最新影视资讯、热门内容推荐，还是新平台入驻信息，都会在第一时间同步更新，确保用户获取到最新、最全的视频资源导航。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            您可能想了解
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            关于青青草视频的常见问题解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col gap-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-100 rounded-xl p-5 border border-background-200/70"
              >
                <h3 className="text-sm font-bold text-foreground-900 mb-2 flex items-start gap-2">
                  <span className="text-primary-500 flex-shrink-0 font-heading">Q{idx + 1}.</span>
                  {item.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-0 md:pl-6">{item.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}